import React from "react";
import { SelectList } from "@common/selectList";
import { AddAllocationIcon } from "@common/assets/addAllocationIcon";
import { ResourceAllocationMenu } from "@common/resourceAllocationMenu";
import { Props } from "./types";
import { Resource } from "./resource";
import styles from "./styles.scss";

function ParticipantsList({ project, participants, select, remove }: Props) {
  return (
    <div className={styles.participantsList}>
      {participants.length > 0 && (
        <div className={styles.participants}>
          {participants.map((participant) => (
            <div className={styles.participant}>
              <Resource
                resource={participant}
                select={remove ? () => remove([participant]) : undefined}
              />
            </div>
          ))}
        </div>
      )}
      {select && remove && (
        <SelectList
          rootClassName={styles.root}
          inputClassName={styles.root}
          listClassName={styles.list}
          multiple
        >
          {() => ({
            input: <AddAllocationIcon className={styles.addParticipantIcon} />,
            list: (
              <ResourceAllocationMenu
                allocatedResources={participants}
                select={select}
                unSelect={remove}
                openedViews={["resources"]}
              />
            ),
          })}
        </SelectList>
      )}
    </div>
  );
}

export { ParticipantsList };
